import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "mealtimeInput", "deliveryDateInput", "typeOfDietInput", "formContainer", "title"]

  connect() {
  }

  newMenuHandleClick(event) {
    event.preventDefault();
    this.mealtimeInputTarget.value = event.currentTarget.dataset.mealtime
    this.deliveryDateInputTarget.value = event.currentTarget.dataset.deliveryDate
    this.typeOfDietInputTarget.value = event.currentTarget.dataset.typeOfDiet
    
    // Actualizar título
    if (this.hasTitleTarget) {
      this.titleTarget.textContent = "Nuevo Menú"
    }
    
    this.positionSidebar(event.currentTarget.dataset.mealtime)
    this.containerTarget.classList.add("show")
  }

  editMenuHandleClick(event) {
    event.preventDefault();
    const menuId = event.currentTarget.dataset.menuId
    const menuMealtime = event.currentTarget.dataset.menuMealtime
    
    // Actualizar título
    if (this.hasTitleTarget) {
      this.titleTarget.textContent = "Editar Menú"
    }
    
    // Cargar el formulario de edición
    this.loadEditForm(menuId)
    
    this.positionSidebar(menuMealtime)
    this.containerTarget.classList.add("show")
  }

  loadEditForm(menuId) {
    // Cargar el formulario de edición
    if (this.hasFormContainerTarget) {
      fetch(`/menus/${menuId}/edit`, {
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, 'text/html')
        const formContainer = doc.querySelector('.border.px-3.py-4.rounded.shadow.bg-white') || doc.querySelector('form')?.parentElement
        if (formContainer && this.hasFormContainerTarget) {
          this.formContainerTarget.innerHTML = formContainer.innerHTML || doc.querySelector('form').outerHTML
          
          // Reinicializar los controladores de Stimulus si es necesario
          this.initializeStimulusControllers()
        }
      })
      .catch(error => console.error('Error loading edit form:', error))
    }
  }

  initializeStimulusControllers() {
    // Reinicializar controladores de Stimulus en el contenido cargado
    if (window.Stimulus) {
      window.Stimulus.load()
    }
  }

  positionSidebar(mealtime) {
    if (["Media Tarde", "Merienda", "Cena"].includes(mealtime)) {
      this.containerTarget.classList.remove("right", "center")
      this.containerTarget.classList.add("left")
    } else {
      this.containerTarget.classList.remove("left", "center")
      this.containerTarget.classList.add("right")
    }
  }

  closeForm(event) {
    event.preventDefault();
    
    // Resetear el formulario si existe
    if (this.hasFormContainerTarget) {
      const form = this.formContainerTarget.querySelector('form')
      if (form) {
        form.reset()
        // Limpiar errores de validación
        const errorElements = form.querySelectorAll('.text-danger, .error, .field_with_errors')
        errorElements.forEach(el => {
          el.classList.remove('text-danger', 'error', 'field_with_errors')
          if (el.tagName === 'DIV' && el.children.length === 0) {
            el.remove()
          }
        })
        // Limpiar campos de productos dinámicos
        const nestedFormContainer = form.querySelector('[data-target="nested-form.container"]')
        if (nestedFormContainer) {
          // Mantener solo el primer campo, eliminar los demás
          const productFields = nestedFormContainer.querySelectorAll('.nested-fields, [data-nested-form-field]')
          if (productFields.length > 1) {
            productFields.forEach((field, index) => {
              if (index > 0) {
                field.remove()
              } else {
                // Resetear el primer campo
                const select = field.querySelector('select')
                if (select) {
                  select.value = ''
                }
              }
            })
          } else if (productFields.length === 1) {
            const select = productFields[0].querySelector('select')
            if (select) {
              select.value = ''
            }
          }
        }
      }
    }
    
    // Cerrar el sidebar
    this.containerTarget.classList.remove("show")
    setTimeout(() => {
      this.containerTarget.classList.remove("left", "center", "right")
      // Resetear el título
      if (this.hasTitleTarget) {
        this.titleTarget.textContent = "Nuevo Menú"
      }
    }, 500)
  }

  alignDock(event) {
    this.containerTarget.dataset.newDock = event.currentTarget.dataset.align
    this.containerTarget.classList.remove("show")
    setTimeout(() => {
      this.containerTarget.classList.remove("left", "center", "right")
    }, 300)
    setTimeout(() => {
      this.containerTarget.classList.add(this.containerTarget.dataset.newDock)
    }, 310)
    setTimeout(() => {
      this.containerTarget.classList.add("show")
    }, 320)
  }
}
